<template>
  <div class='jump-pay'>
    <van-popup
      v-model="isShow"
      closeable
      class="jump-pay_popup"
    >

      <div class="jump-pay_inner">

        <div class="jump-pay_inner_title">
          
          <span v-if="replicated">支付状态</span>

          <span v-else>友情提示</span>
        </div>

        <div class="jump-pay_inner_desc">
          <span v-if="replicated">是否在其他浏览器完成支付？</span>

          <span v-else>请您复制下方链接地址，在您手机的其他浏览器中打开，继续完成支付。</span>
        </div>

        <div
          class="jump-pay_inner_url"
          v-if="!replicated"
        >
          {{ url }}
        </div>

        <div class="jump-pay_inner_button">
          <van-button
            color="#0066ff"
            block
            v-if="replicated"
            @click="paid"
          >我已支付</van-button>

          <van-button
            id="btn-copy"
            color="#0066ff"
            block
            :data-clipboard-text="url"
            v-else
          >一键复制</van-button>
        </div>

      </div>

    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { Notify } from 'vant';
import ClipboardJS from 'clipboard'

Vue.use(Notify);

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ""
    },
    accountUid: {
      type: String,
      default: ""
    },
    projectUid: {
      type: String,
      default: ""
    },
    orderNo: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    return {
      replicated: false // 已复制，切换提示
    };
  },
  watch: {},
  created() { },
  mounted() {
    const _this = this

    const clipboard = new ClipboardJS('#btn-copy');

    clipboard.on('success', function (e) {
      Notify({ type: 'success', message: '复制成功' });

      // 过滤当前页 = 结果页
      if (location.href.indexOf('result') !== -1) {
        _this.replicated = true
        return
      }

      // 跳转结果页（等待支付）
      _this.$router.push(`/result/${_this.accountUid}/${_this.projectUid}/${_this.orderNo}`)
      console.log('_this.orderNo: ', _this.orderNo)
    });

    clipboard.on('error', function (e) {
      Notify({ type: 'error', message: '请手动复制链接' });
    });
  },
  computed: {},
  methods: {
    paid() {
      location.reload()
    }
  }
};
</script>

<style lang="less" scoped>
// @import "~@a/less/";
.jump-pay {
  .jump-pay_inner {
    margin-top: 20px;
    padding-left: 16px;
    padding-right: 16px;
    margin-bottom: 16px;
    box-sizing: border-box;

    .jump-pay_inner_title {
      font-weight: 700;
      font-size: 16px;
    }

    .jump-pay_inner_desc {
      margin-top: 20px;
      font-size: 14px;
      line-height: 20px;
    }

    .jump-pay_inner_url {
      margin-top: 16px;
      word-break: break-all;
      line-height: 18px;
      font-size: 14px;
      color: #1071d3;
      background: #ecf9ff;
      padding: 16px;
      border-radius: 4px;
    }

    .jump-pay_inner_button {
      margin-top: 16px;
    }
  }

  .jump-pay_popup {
    width: 90vw;
    border-radius: 4px;
  }
}
</style>
